import RestService from '@core/services/lotto/_private/RestService';
import { LottoSort } from '@core/services/lotto/_private/enums';
import LottoEvent from '@core/models/lotto/LottoEvent';
import LottoEventMapper from '@core/mappers/lotto/LottoEventMapper';
import LottoGame from '@core/models/lotto/LottoGame';
import LottoGameMapper from '@core/mappers/lotto/LottoGameMapper';
import IResponse from '@core/utils/types/IResponse';
import ILottoEventDto from '@core/mappers/lotto/dtos/ILottoEventDto';
import ILottoGameDto from '@core/mappers/lotto/dtos/ILottoGameDto';
import * as NetworkUtils from '@utils/network/NetworkUtils';
import { instanceGuard } from '@utils/services';
import ServerConfig from '@models/country/ServerConfig';
import SingletonError from '../common/errors/SingletonError';
import Singleton from '../common/Singleton';

const lottoEventMapper: LottoEventMapper = new LottoEventMapper();
const lottoGameMapper: LottoGameMapper = new LottoGameMapper();

export interface Dependencies {
    offerHostProvider: { getCurrentOfferHost: () => string };
}

class LottoService {
    private static instance: LottoService;
    private restService: RestService;

    private constructor(private config: ServerConfig, { offerHostProvider }: Dependencies) {
        if (LottoService.instance) {
            throw new SingletonError(this.constructor.name);
        }
        console.log('SSBT::LottoService hostServer >>', offerHostProvider.getCurrentOfferHost());
        this.restService = new RestService(offerHostProvider.getCurrentOfferHost());
    }

    public static getInstance(): LottoService {
        return instanceGuard(LottoService.instance);
    }

    public static createInstance(config: ServerConfig, dependencies: Dependencies) {
        if (!LottoService.instance) {
            LottoService.instance = new LottoService(config, dependencies);
        }
        return LottoService.instance;
    }

    public async getLottoOffer(startDate: Date, endDate: Date, sort: LottoSort = LottoSort.utc): Promise<LottoEvent[]> {
        const response: IResponse<ILottoEventDto[]> = await NetworkUtils.processResponse(
            this.restService.getLottoOffer(startDate, endDate, sort)
        );
        return lottoEventMapper.map(response.data, true);
    }

    public async getLottoEventDetails(lottoIds: number[]): Promise<LottoEvent[]> {
        const response: IResponse<ILottoEventDto[]> = await NetworkUtils.processResponse(
            this.restService.getLottoDetails(lottoIds)
        );
        return lottoEventMapper.map(response.data, true);
    }

    public async getLottoGames(): Promise<LottoGame[]> {
        const response: IResponse<ILottoGameDto[]> = await NetworkUtils.processResponse(
            this.restService.getLottoGames()
        );
        return lottoGameMapper.map(response.data, true);
    }

    public async getLottoEventResults(startDate: Date, endDate: Date): Promise<LottoEvent[]> {
        const response: IResponse<ILottoEventDto[]> = await NetworkUtils.processResponse(
            this.restService.getLottoEventResults(startDate, endDate)
        );
        return lottoEventMapper.map(response.data, true);
    }

    public static clearInstance() {
        if (process.env.NODE_ENV !== 'test') {
            throw new Error('For use in tests only');
        }
        delete LottoService.instance;
    }
}

export default LottoService as Singleton<LottoService>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/lotto/LottoService.ts